import Avatar from 'antd/lib/avatar';
import 'antd/lib/avatar/style/css';
import React from 'react';

const WrappedAvatar = props => <Avatar icon="user" {...props} />;

WrappedAvatar.defaultProps = {
  src:
    'https://popsloth.files.wordpress.com/2015/03/sloth___the_goonies_by_bezerkartwerk-d6ftf38.jpg',
};

export default WrappedAvatar;



// WEBPACK FOOTER //
// ./src/components/common/Avatar/index.js